module.exports = __webpack_public_path__ + "img/cloudImg1.5b796916.png";